import { apiGet } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';

export const dealsLogApiAdapter = {
  getDealsReport: (params) => {
    return apiGet(DEALS_PATHS.dealsReport, { params, responseType: 'blob' });
  },
};
